import React from 'react';
import { DisplayableItem } from './display/media-displayer';

export interface Props {
  active: boolean;
  item: DisplayableItem;
  onClick: (item: DisplayableItem) => void;
}

const MediaGalleryItemView: React.FC<Props> = ({ active, item, onClick }: Props) => {
  const handleClick = () => {
    onClick(item);
  };

  const activeStyle = active ? {
    border: '3px solid #fff',
    backgroundColor: '#fff',
    fill: '#000',
  } : {};

  return item.displayer.thumbnail(item.item, handleClick, activeStyle);
};

export default MediaGalleryItemView;
